import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "remove" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 4.5,
			y1: 19.5,
			x2: 19.5,
			y2: 4.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 4.5,
			y1: 4.5,
			x2: 19.5,
			y2: 19.5
		})
	]
});
export default SvgRemove;
